import { Record } from "immutable";

export type QuestionStatType = {
  mark?: number;
  marksTotal?: number;
  selfMark?: number;
  teacherMark?: number;
  needsMarking?: number;
  confidence?: number;
  studyTime?: number;
  flagged?: boolean;
  answerTimeCreated?: string;
};

export const defaultQuestionStat: QuestionStatType = {
  mark: undefined,
  marksTotal: undefined,
  studyTime: undefined,
  selfMark: undefined,
  teacherMark: undefined,
  needsMarking: undefined,
  confidence: undefined,
  flagged: undefined,
  answerTimeCreated: undefined
};

export default class QuestionStat extends Record(defaultQuestionStat) {}
